import { render, staticRenderFns } from "./PonudaBrowse.vue?vue&type=template&id=c479c10e"
import script from "./PonudaBrowse.vue?vue&type=script&lang=js"
export * from "./PonudaBrowse.vue?vue&type=script&lang=js"
import style0 from "./PonudaBrowse.vue?vue&type=style&index=0&id=c479c10e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports